/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Ptz_DownInputs */

const vi_grower_area_camera_ptz_down = /** @type {(inputs: Grower_Area_Camera_Ptz_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay xuống`)
};

/**

* @param {Grower_Area_Camera_Ptz_DownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_ptz_down = /** @type {((inputs?: Grower_Area_Camera_Ptz_DownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Ptz_DownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_ptz_down(inputs)
});